import React, { useEffect, useRef, useState } from "react";
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import { Line } from 'react-chartjs-2';
import { store } from 'react-notifications-component';

import api from "../../../services/api";
import { isTotvs } from "../../../services/globalFunctions";
import { formatDate } from '../../../services/formatDate';
import downloadFile from "../../../utils/downloadFile";

import Graphics from "./Graphics";
import FunctionBlockedOverlay from "../../functionBlocked";
import Modal from "../../modal/modalFuncaoBloqueadaImpressaoFe";
import ModalAlertTotvs from '../../../components/modal/modalAlertTotvs';

import identifyErrorMenssage from "../../../services/identifyErrorMenssage";

import { Loading } from "../../loading";
import * as S from './styles';
import { theme } from "../../../styles/theme";
import { ChartArea, IconeBotao } from './styles';
import { H6, TaglineM } from "../../../styles/stylesTypography";

import graphics from '../../../assets/icons/icon-bar-char-blue.png';
import document from '../../../assets/icons/document.svg';
const isFunctionBlocked = (user) => {
  const planId = user?.contrato?.agro_plan_config?.agro_plan_id;
  const diasRestante = Number(user?.contrato?.dias_restante ?? 0);
  return (
    planId === 7 ||
    planId === 6 ||
    planId === 4 ||
    (planId === 1 && diasRestante <= 0)
  );
};

const getUserFromStorage = () => {
  try {
    return JSON.parse(localStorage.getItem("@userinfo"));
  } catch {
    return null;
  }
};

const TreatedArea = ({overlayMode = "self", ...props}) => {
    const [selectedOption, setSelectedOption] = useState(props.isTotvs ? "Receitas Emitidas" : "Área tratada (ha)");
    const [loading, setLoading] = useState(true);
    const [totalTratada, setTotalTratada] = useState([]);
    const [graphicsData, setGraphicsData] = useState({ produtos: [], culturas: [], alvos: [] });

    const blockedRef = useRef(null);
    const [openModalTrue, setOpenModalTrue] = useState(false);
    const isBlocked = isFunctionBlocked(getUserFromStorage());

    const today = new Date();
    const priorDate = new Date(new Date().setDate(today.getDate() - 183));
    const [dataInicial, setDataInicial] = useState(priorDate.toISOString().slice(0, 10));
    const [dataFinal, setDataFinal] = useState(today.toISOString().slice(0, 10));
    const [dataGraph, setDataGraph] = useState([]);
    const [optionsGraph, setOptionsGraph] = useState([]);
    const [showChart, setShowChart] = useState(false);
    const [loadingXls, setShowLoadingXls] = useState(false);
    const [initialLoaded, setInitialLoaded] = useState(false);

    const tour = localStorage.getItem("startTour");

    const [showModalTotvs, setShowModalTotvs] = useState(false);

    const searchInitialData = async () => {
        try {
            const response = await api.post('/relatorios/receitas/grafico', {
                dtInicial: dataInicial,
                dtFinal: dataFinal
            });

            setDataGraph({
                labels: response.data.meses,
                datasets: [
                    {
                        label: 'Receitas',
                        data: response.data.qtdReceita,
                        backgroundColor: 'rgb(47, 187, 105, 0.4)',
                        borderColor: 'rgb(47, 187, 105, 1)',
                        borderWidth: 1,
                        tension: 0.3,
                    },
                ],
            });

            setOptionsGraph({
                responsive: true,
                scales: {
                    y: {
                        beginAtZero: true,
                        ticks: {
                            stepSize: 1,
                        },
                    },
                    x: {
                        ticks: {
                            font: {
                                size: 14,
                            },
                            stepSize: 1,
                        },
                    },
                },
                plugins: {
                    legend: {
                        position: 'top',
                    },
                    title: {
                        display: true,
                        text: `Total de receitas emitidas por mês de ${formatDate(dataInicial)} à ${formatDate(dataFinal)}`,
                    },
                },
            });

            setInitialLoaded(true);
            setShowChart(true);
        } catch (error) {

        }
    }

    const updateData = async () => {
        if (initialLoaded) {
            try {
                const response = await api.post('/relatorios/receitas/grafico', {
                    dtInicial: dataInicial,
                    dtFinal: dataFinal,
                })

                setDataGraph({
                    labels: response.data.meses,
                    datasets: [
                        {
                            label: 'Receitas',
                            data: response.data.qtdReceita,
                            backgroundColor: 'rgb(47, 187, 105, 0.4)',
                            borderColor: 'rgb(47, 187, 105, 1)',
                            borderWidth: 1,
                            tension: 0.3,
                        },
                    ],
                });

                setOptionsGraph({
                    responsive: true,
                    indexAxis: 'x',
                    scales: {
                        y: {
                            beginAtZero: true,
                            ticks: {
                                stepSize: 1,
                            },
                        },
                        x: {
                            ticks: {
                                font: {
                                    size: 14,
                                },
                                stepSize: 1,
                            },
                        },
                    },
                    plugins: {
                        legend: {
                            position: 'top',
                        },
                        title: {
                            display: false,
                            text: `Total de receitas emitidas por mês de ${formatDate(dataInicial)} à ${formatDate(dataFinal)}`,
                        },
                    },
                });

                setShowChart(true);
            } catch (error) {

            }
        }
    }

    const gerarXLS = async () => {
        const payload = {
            dtInicial: dataInicial,
            dtFinal: dataFinal,
        }

        try {
            setShowLoadingXls(true);
            window.onbeforeunload = () => 'Seu relatório está sendo gerado. Tem certeza que deseja sair?';

            const response = await api.post(`/relatorios/geral`, payload)

            if (response.data.downloadUrl) {
                await downloadFile(response.data.downloadUrl, 'relatorio-receitas.xlsx');
            }

            store.addNotification({
                title: "Sucesso!",
                message: "Relatório gerado com sucesso.",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 6000,
                    onScreen: true
                }
            });

        } catch (error) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(error),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        } finally {
            setShowLoadingXls(false);
            window.onbeforeunload = null;
        }
    }

    useEffect(() => {
        searchInitialData();
    }, [])

    useEffect(() => {
        updateData();
    }, [dataInicial, dataFinal])

    const getAreaTratada = async () => {
        try {
            const response = await api.get("/home/area-tratada");
            if (!response.data || !response.data.data) {
                setTotalTratada([]); // Define como array vazio se não houver dados
                return;
            }

            setTotalTratada(response.data.data);
        } catch (error) {
        }
    };

    const getGraphicsData = async () => {
        try {
            // API limita o período dos relatórios a 24 meses (PERIODO_MAX_MESES)
            const now = new Date();
            const start = new Date(now);
            start.setUTCMonth(start.getUTCMonth() - 24);
            const requestBody = {
                dtInicial: start.toISOString().split('T')[0],
                dtFinal: now.toISOString().split('T')[0],
            };

            const [produtos, culturas, alvos] = await Promise.all([
                api.post('/relatorios/produtos/grafico', requestBody),
                api.post('/relatorios/culturas/grafico', requestBody),
                api.post('/relatorios/alvos/grafico', requestBody),
            ]);

            setGraphicsData({
                produtos: produtos.data.data,
                culturas: culturas.data.data,
                alvos: alvos.data.data,
            });

        } catch (error) {
        }
    };

    useEffect(() => {
        getAreaTratada();
        getGraphicsData();
    }, []);

    useEffect(() => {
        setLoading(true);
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1000);
        return () => clearTimeout(timer);
    }, [selectedOption]);

    const formatDataForChart = () => {
        if (!Array.isArray(totalTratada) || totalTratada.length === 0) return [];

        // Normaliza e já guarda a Date real para evitar recriação por label
        const normalized = totalTratada.map((item) => {
            // item.mes pode vir "YYYY-MM-01" ou "YYYY-MM-01T00:00:00"
            const raw = String(item.mes);
            const iso = raw.includes("T") ? raw : `${raw}T00:00:00`;
            const d = new Date(iso);

            // se ainda assim vier inválida, aborta silenciosamente este ponto
            if (isNaN(d.getTime())) return null;

            const mes = d.toLocaleDateString("pt-BR", { month: "short" }).toUpperCase().replace(".", "");
            const ano = d.getFullYear().toString().slice(-2);

            return {
                _date: d,                  // guarda referência da data
                mes: `${mes}/${ano}`,      // label para o gráfico
                area_total: item.total_area ?? 0,
            };
        }).filter(Boolean);

        if (normalized.length === 0) return [];

        // Se só há um ponto, insere o mês anterior com área = 0
        if (normalized.length === 1) {
            const only = normalized[0];
            const prev = new Date(only._date.getTime());
            prev.setMonth(prev.getMonth() - 1);

            const mesPrev = prev.toLocaleDateString("pt-BR", { month: "short" }).toUpperCase().replace(".", "");
            const anoPrev = prev.getFullYear().toString().slice(-2);

            normalized.unshift({
                _date: prev,
                mes: `${mesPrev}/${anoPrev}`,
                area_total: 0,
            });
        }

        // Remove o campo interno antes de entregar ao Recharts
        return normalized.map(({ mes, area_total }) => ({ mes, area_total }));
    };

    const formatFakeDataForChart = () => {
        // Gera dados fictícios de jan/2025 até o mês atual
        const generateFakeData = () => {
            const out = [];
            const now = new Date();
            for (let y = 2025; y <= now.getFullYear(); y++) {
                const mStart = 0; // jan
                const mEnd = y === now.getFullYear() ? now.getMonth() : 11; // até o mês atual no ano corrente
                const dadosFixos = [180, 95, 150, 75, 120, 165, 88, 135, 110, 175, 92, 145];

                for (let m = mStart; m <= mEnd; m++) {
                    const dt = new Date(Date.UTC(y, m, 1)); // estável
                    out.push({
                        mes: dt.toISOString().slice(0, 10),   // "YYYY-MM-DD"
                        total_area: dadosFixos[m] ?? 100,
                    });
                }
            }
            return out;
        };

        const dataSource = (Array.isArray(totalTratada) && totalTratada.length > 0)
            ? totalTratada
            : generateFakeData();

        // Reusa a mesma lógica da função real para evitar divergência
        const temp = dataSource.map((item) => {
            const raw = String(item.mes);
            const iso = raw.includes("T") ? raw : `${raw}T00:00:00`;
            const d = new Date(iso);
            if (isNaN(d.getTime())) return null;

            const mes = d.toLocaleDateString("pt-BR", { month: "short" }).toUpperCase().replace(".", "");
            const ano = d.getFullYear().toString().slice(-2);
            return { _date: d, mes: `${mes}/${ano}`, area_total: item.total_area ?? 0 };
        }).filter(Boolean);

        if (temp.length === 0) return [];

        if (temp.length === 1) {
            const only = temp[0];
            const prev = new Date(only._date.getTime());
            prev.setMonth(prev.getMonth() - 1);

            const mesPrev = prev.toLocaleDateString("pt-BR", { month: "short" }).toUpperCase().replace(".", "");
            const anoPrev = prev.getFullYear().toString().slice(-2);

            temp.unshift({ _date: prev, mes: `${mesPrev}/${anoPrev}`, area_total: 0 });
        }

        return temp.map(({ mes, area_total }) => ({ mes, area_total }));
    };

    const areaTratada = () => {
        return totalTratada.length === 0 ? (
            <>
                {tour === "true" ? (
                    <S.ChartContainer>
                        <ResponsiveContainer width="100%" height="100%">
                            <AreaChart data={formatFakeDataForChart()} margin={{ top: 20, right: 30, left: -10, bottom: 5 }}>
                                <defs>
                                    <linearGradient id="colorGreen" x1="0" y1="0" x2="0" y2="1">
                                        <stop offset="0%" stopColor={theme.colors.green.Verde_AgroReceita} stopOpacity={0.4} />
                                        <stop offset="100%" stopColor={theme.colors.green.Verde_AgroReceita} stopOpacity={0} />
                                    </linearGradient>
                                </defs>

                                <XAxis
                                    dataKey="mes"
                                    tick={{ fontSize: 12, fill: "#21262F" }}
                                    tickLine={false}
                                    axisLine={false}
                                    padding={{ left: 10, right: 10 }}
                                />

                                <YAxis
                                    tick={{ fontSize: 12, fill: "#21262F" }}
                                    tickLine={false}
                                    axisLine={false}
                                />

                                <Tooltip />

                                <Area
                                    type="monotone"
                                    dataKey="area_total"
                                    stroke={theme.colors.green.Verde_AgroReceita}
                                    strokeWidth={2}
                                    fill="url(#colorGreen)"
                                />
                            </AreaChart>
                        </ResponsiveContainer>
                    </S.ChartContainer>
                ) : (
                    <>
                        <H6 color={theme.colors.gray.Cinza_2} style={{ textAlign: "center" }}>
                            Emita seu primeiro Receituário para ver os relatórios
                        </H6>

                        <S.ButtonHeader onClick={() => { 
                            if (isTotvs()) {
                                setShowModalTotvs(true);
                            } else {
                                window.location.href = "/receitas/add";
                            }
                            }}>
                            <img src={document} alt="Ícone de documento" />

                            <TaglineM color={theme.colors.white.Branco} fontWeight={800}>EMITIR NOVA RECEITA</TaglineM>
                        </S.ButtonHeader>

                         <ModalAlertTotvs
                            show={showModalTotvs}
                            marginBottom="0"
                            onHide={() => setShowModalTotvs(false)}
                            />
                    </>
                )}
            </>
        ) : (
            <S.ChartContainer>
                <ResponsiveContainer width="100%" height="100%">
                    <AreaChart data={formatDataForChart()} margin={{ top: 20, right: 30, left: -10, bottom: 5 }}>
                        <defs>
                            <linearGradient id="colorGreen" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="0%" stopColor={theme.colors.green.Verde_AgroReceita} stopOpacity={0.4} />
                                <stop offset="100%" stopColor={theme.colors.green.Verde_AgroReceita} stopOpacity={0} />
                            </linearGradient>
                        </defs>

                        <XAxis
                            dataKey="mes"
                            tick={{ fontSize: 12, fill: "#21262F" }}
                            tickLine={false}
                            axisLine={false}
                            padding={{ left: 10, right: 10 }}
                        />

                        <YAxis
                            tick={{ fontSize: 12, fill: "#21262F" }}
                            tickLine={false}
                            axisLine={false}
                        />

                        <Tooltip />

                        <Area
                            type="monotone"
                            dataKey="area_total"
                            stroke={theme.colors.green.Verde_AgroReceita}
                            strokeWidth={2}
                            fill="url(#colorGreen)"
                        />
                    </AreaChart>
                </ResponsiveContainer>
            </S.ChartContainer>
        );
    };

    const problemasMaisFrequentes = () =>
        graphicsData.produtos.produtos?.length == 0 ? (
            <>
                <H6 color={theme.colors.gray.Cinza_2} style={{ textAlign: "center", marginTop: "40px" }}>
                    Emita seu primeiro Receituário para ver os relatórios
                </H6>

                <S.ButtonHeader style={{ marginBottom: "20px" }} onClick={() => {
                    if (isTotvs()) {
                        setShowModalTotvs(true);
                    } else {
                        window.location.href = "/receitas/add";
                    }
                    }}>
                    <img src={document} alt="Ícone de documento" />

                    <TaglineM color={theme.colors.white.Branco} fontWeight={800}>EMITIR NOVA RECEITA</TaglineM>
                </S.ButtonHeader>

                <ModalAlertTotvs
                    show={showModalTotvs}
                    marginBottom="0"
                    onHide={() => setShowModalTotvs(false)}
                    />
            </>
        ) : (
            <S.ContainerGraphics>
                {graphicsData.produtos && graphicsData.produtos.produtos?.length > 0 && (
                    <Graphics data={graphicsData.produtos} />
                )}

                {graphicsData.culturas && graphicsData.culturas.culturas?.length > 0 && (
                    <Graphics data={graphicsData.culturas} />
                )}

                {graphicsData.alvos && graphicsData.alvos.pests?.length > 0 && (
                    <Graphics data={graphicsData.alvos} />
                )}
            </S.ContainerGraphics>
        );

    const receitasEmitidas = () => {
        return totalTratada.length === 0 ? (
            <>
                <H6 color={theme.colors.gray.Cinza_2} style={{ textAlign: "center" }}>
                    Emita seu primeiro Receituário para ver os relatórios
                </H6>

                <S.ButtonHeader onClick={() => {
                    if (isTotvs()) {
                        setShowModalTotvs(true);
                    } else {
                        window.location.href = "/receitas/add";
                    }
                    }}>
                    <img src={document} alt="Ícone de documento" />

                    <TaglineM color={theme.colors.white.Branco} fontWeight={800}>EMITIR NOVA RECEITA</TaglineM>
                </S.ButtonHeader>

                <ModalAlertTotvs
                    show={showModalTotvs}
                    marginBottom="0"
                    onHide={() => setShowModalTotvs(false)}
                    />
            </>
        ) : (
            <S.ChartContainer>
                <>
                    <div>
                        <hr style={{
                            marginTop: '7px',
                            marginBottom: '0px'
                        }} />
                    </div>
                    {showChart && loadingXls == false ? (
                        <>

                            <ChartArea style={{
                                margin: 'auto',
                            }}>
                                <Line
                                    data={dataGraph}
                                    height={250}
                                    options={{
                                        plugins: {
                                            legend: {
                                                display: false,
                                            },
                                            title: {
                                                display: false,
                                                text: 'Receitas emitidas por mês',
                                            },
                                        },
                                        scales: {
                                            y: {
                                                beginAtZero: true,
                                                ticks: {
                                                    stepSize: 1,
                                                }
                                            }
                                        },
                                        maintainAspectRatio: false,

                                    }}
                                />
                            </ChartArea>
                        </>
                    ) : (<Loading />)}
                </>
            </S.ChartContainer>
        );
    };

    const renderOptions = {
        "Área tratada (ha)": areaTratada,
        "Problemas mais frequentes": problemasMaisFrequentes,
        "Receitas Emitidas": receitasEmitidas,
    };

    return (
        <>
        <S.Container ref={blockedRef} className="treatedArea" isFrequentProblemsSelected={selectedOption === "Problemas mais frequentes"}>
            <S.Header>
                {tour === "true" ? (
                    <S.FarmSelect value={selectedOption} onChange={(e) => setSelectedOption(e.target.value)}>
                        <option value="Área tratada (ha)">Área tratada (ha)</option>
                    </S.FarmSelect>
                ) : (
                    <S.FarmSelect value={selectedOption} onChange={(e) => setSelectedOption(e.target.value)}>
                        <option value="Área tratada (ha)">Área tratada (ha)</option>
                        <option value="Problemas mais frequentes">Problemas mais frequentes</option>
                        <option value="Receitas Emitidas">Receitas Emitidas</option>
                    </S.FarmSelect>
                )}

                {tour === "true" ? (
                    <>
                    </>
                ) : (
                    <S.Report onClick={() => window.location = '/relatorios'}>
                        <img src={graphics} alt="Ícone de gráficos" style={{ width: "16px" }} />

                        <TaglineM color={theme.colors.blue.Azul_link} fontWeight={800}>VER RELATÓRIOS</TaglineM>
                    </S.Report>

                )}

            </S.Header>

            <S.Body>
                {loading ? <Loading size="75px" /> : renderOptions[selectedOption]?.()}
            </S.Body>

            {overlayMode !== "none" && isBlocked && (
              <FunctionBlockedOverlay
                visible
                mode="cover-parent"
                attachTo={blockedRef}
                ctaType="activate"
                onActivate={() => setOpenModalTrue(true)}
              />
            )}
        </S.Container>

        {openModalTrue ? (
          <Modal show={openModalTrue} onHide={() => setOpenModalTrue(false)} />
        ) : null}
        </>
    );
};

export default TreatedArea;
